import { Routes } from '@angular/router';
import { AUTH_RC } from '@shared/navigation/constants/routes.constants';
import { authGuard } from '@shared/guards/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: AUTH_RC.root,
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/authorized-content/authorized-content.routes').then((m) => m.AUTHORIZED_CONTENT_ROUTES),
  },
];
